import { GzEndpointModulesStatusWebComponent } from './component/EndpointModulesStatusWebComponent';

export { GzEndpointModulesStatusWebComponent };
